import PropTypes from "prop-types";
import { TD, TR } from "./BusinessDashboard/Table/Table";

const LeadSourceTotalRow = ({ statusCounts, totalLeadCount }) => (
  <TR>
    <TD>
      <strong>Totals</strong>
    </TD>
    <TD>
      <strong>{statusCounts.new}</strong>
    </TD>
    <TD>
      <strong>{statusCounts.unqualified}</strong>
    </TD>
    <TD>
      <strong>{statusCounts.watch}</strong>
    </TD>
    <TD>
      <strong>{statusCounts.nurture}</strong>
    </TD>
    <TD>
      <strong>{statusCounts.hot}</strong>
    </TD>
    <TD>
      <strong>{statusCounts.past}</strong>
    </TD>
    <TD>
      <strong>{statusCounts.inactive}</strong>
    </TD>
    <TD>
      <strong>{statusCounts.archived}</strong>
    </TD>
    <TD>
      <strong>{statusCounts.trash}</strong>
    </TD>
    <TD>
      <strong>{totalLeadCount}</strong>
    </TD>
  </TR>
);

LeadSourceTotalRow.propTypes = {
  statusCounts: PropTypes.shape().isRequired,
  totalLeadCount: PropTypes.number.isRequired,
};

export default LeadSourceTotalRow;
